import { render, staticRenderFns } from "./StartApp.vue?vue&type=template&id=3b8ba998&"
import script from "./StartApp.vue?vue&type=script&lang=ts&"
export * from "./StartApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports